export interface Notification {
    message: string | null;
    severity?: 'error' | 'warning' | 'info' | 'success';
    duration?: number;
}

export const defaultNotificationValue: Notification = {
    message: null,
    severity: 'info',
};
